import type { components, paths } from "@repo/api-types/merchant"
import { createTypedClient } from "@/api/typed/client"
import { getConfig } from "@/api/utils"
import { service2 as service } from "@/utils/service"

const baseOptions = getConfig({ prefix: "/teashop_merchant" })
const typedClient = createTypedClient<paths>({
  service,
  defaults: {
    baseURL: baseOptions.baseURL,
    headers: baseOptions.headers,
    timeout: baseOptions.timeout,
  },
})

export type TableRuntimeSync = components["schemas"]["TableRuntimeSyncResponse"]
export type TableRuntimeSnapshotRangeRequest =
  components["schemas"]["TableRuntimeSnapshotRangeRequest"]
export type TableRuntimeBillingGroup =
  components["schemas"]["TableRuntimeBillingGroupResponse"]
export type TableRuntimePhysicalTable =
  components["schemas"]["TableRuntimePhysicalTableResponse"]

/** Transport-only entry point. A later page cutover owns envelope interpretation. */
export function getTableRuntimeSnapshot() {
  return typedClient.get("/merchant/table/runtime-snapshot/v1")
}

/** IDs remain decimal strings so JavaScript never rounds backend long identifiers. */
export function getTableRuntimeRangeSnapshot(
  request: TableRuntimeSnapshotRangeRequest,
) {
  return typedClient.post(
    "/merchant/table/runtime-snapshot/v1/range",
    request,
  )
}
